import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/review-approval-states/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const reviewApprovalStates = {
  getAll: apiPathFunc(pathBase),
} as const;
